import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../utils/withRouter';
import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import withStyles from '@mui/styles/withStyles';
import cloneDeep from 'lodash.clonedeep';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { dateTimeToString, niceDateFromString } from '../../utils/date';
import { isNullOrUndefined } from '../../utils/objects';
import { getUser } from '../../utils/sessions';
import { joinDefined } from '../../utils/strings';
import Typography from '../form/Typography';
import UserCircle from '../form/UserCircle';
import CommentsIcon from '../icon/CommentsIcon';
import RepeatIcon from '../icon/RepeatIcon';
import TickIcon from '../icon/TickIcon';
import FlexGrid from '../layout/FlexGrid';
import Grid from '../layout/Grid';
import Inline, { inlineAlignment } from '../layout/Inline';
import Button from '../form/Button';
import RecurrenceModal from './Modals/RecurrenceModal';
import { getTaskStatus, getTaskStatusClass, taskURLObj, updateTaskFunc } from './TaskConstants';
import TaskStar from './TaskStar';
import CheckableStar from './CheckableStar';
import TickableCircle from './TickableCircle';

class TaskWrapper extends Component {
    constructor(props) {
        super(props);

        this.status = null;
    }

    state = {
        loading: false,
        showRecurrenceModal: false,
        item: null
    };

    static getDerivedStateFromProps({ task }, state) {
        if (!state.item || state.item.ID !== task.ID) {
            const newState = {};
            newState.item = task;
            return newState;
        }

        return null;
    }

    render() {
        const { variant, onClickAction, task } = this.props;
        const { showRecurrenceModal } = this.state;

        this.status = getTaskStatus(task);

        if (!task) return null;

        let card = null;

        if (variant === 'list') card = this.renderListItem(onClickAction);

        if (variant === 'card') card = this.renderCard(onClickAction);

        if (variant === 'goal') card = this.renderGoals(onClickAction);

        if (card) {
            return (
                <Fragment>
                    {card}

                    <RecurrenceModal
                        open={showRecurrenceModal}
                        task={task}
                        onClose={() => this.handleCloseRecurrenceModal()}
                    />
                </Fragment>
            );
        }

        return <span>unknown task variant {variant}</span>;
    }

    renderListItem(onClickAction) {
        const { loading } = this.state;
        const { task } = this.props;
        const item = task;
        const convertDateToCheck = date => !isNullOrUndefined(date);
        const related = taskURLObj(task);
        const me = getUser();
        const myTask = item && item.AssignedMembers.find(e => !!e && Number(e.ID) === Number(me.ID));
        const myStar = myTask && myTask._join.TaskMembers.Starred;
        const statusClass = getTaskStatusClass(task);
        // const objBrand = taskURLObj(task);

        return (
            <div
                role="button"
                tabIndex="0"
                className={`task-card list${!!task.Archived ? ' archived' : ''}`}
                onClick={onClickAction ? () => onClickAction(item) : undefined}
                onKeyUp={onClickAction ? e => (e.key === 'Enter' && onClickAction(item)) || null : undefined}
            >
                <Grid container spacing={1}>
                    <Grid item pc>
                        <Inline alignment={inlineAlignment.rightAlignSiblings} center className="task-header-desktop">
                            <p className={`task-status ${statusClass}`}>
                                <span className="status-label">{this.status}</span>
                            </p>

                            {!!item.RecurFreq && (
                                <span
                                    title={
                                        'Task recurs ' +
                                        (item.RecurEnds
                                            ? 'until ' + niceDateFromString(moment(item.RecurEnds))
                                            : 'forever')
                                    }
                                >
                                    <IconButton className="task-repeat" disabled size="large">
                                        <RepeatIcon />
                                    </IconButton>
                                </span>
                            )}

                            {item.Due && (
                                <p className={'due-date' + (this.status === 'Overdue' ? ' overdue' : '')}>
                                    <span className="bold">Due: </span>
                                    {moment(item.Due).format('ddd, ll')}
                                </p>
                            )}

                            <div>
                                <CheckableStar
                                    value={convertDateToCheck(myStar)}
                                    disabled={loading}
                                    onChange={checked => {
                                        const AssignedMembers = item.AssignedMembers.map(e => {
                                            e._join = {
                                                TaskMembers: {
                                                    Starred:
                                                        Number(e.ID) === Number(me.ID)
                                                            ? checked
                                                                ? new Date()
                                                                : null
                                                            : (e._join && e._join.TaskMembers && e._join.TaskMembers.Starred) || null
                                                }
                                            };
                                            return e;
                                        });
                                        this.onStarChange('AssignedMembers', AssignedMembers);
                                    }}
                                />
                            </div>
                        </Inline>

                        <FlexGrid className="task-header-mobile">
                            <Inline center>
                                <p className={`task-status ${statusClass}`}>
                                    <span className="status-label">{this.status}</span>
                                </p>
                                <p className="record-id-mobile">#{item.ID}</p>
                                {item.Due && (
                                    <p className={'due-date' + (this.status === 'Overdue' ? ' overdue' : '')}>
                                        {moment(item.Due).format('ll')}
                                    </p>
                                )}
                            </Inline>
                            <div className="actions">
                                {!!item.RecurFreq && (
                                    <span
                                        title={
                                            'Task recurs ' +
                                            (item.RecurEnds
                                                ? 'until ' + niceDateFromString(moment(item.RecurEnds))
                                                : 'forever')
                                        }
                                    >
                                        <IconButton className="task-repeat" disabled size="large">
                                            <RepeatIcon />
                                        </IconButton>
                                    </span>
                                )}
                                <TaskStar
                                    value={convertDateToCheck(myStar)}
                                    disabled={loading}
                                    onChange={checked => {
                                        const AssignedMembers = item.AssignedMembers.map(e => {
                                            e._join = {
                                                TaskMembers: {
                                                    Starred:
                                                        Number(e.ID) === Number(me.ID)
                                                            ? checked
                                                                ? new Date()
                                                                : null
                                                            : (e._join && e._join.TaskMembers && e._join.TaskMembers.Starred) || null
                                                }
                                            };
                                            return e;
                                        });
                                        this.onStarChange('AssignedMembers', AssignedMembers);
                                    }}
                                />
                            </div>
                        </FlexGrid>
                    </Grid>
                    <Grid item pc>
                        <div className="left-margin text-section">
                            <h2 className="task-heading">{item.Title}</h2>
                            <p className="task-description">{item.Description}</p>
                        </div>
                    </Grid>

                    <Grid item pc>
                        <div className="left-margin">
                            <Inline alignment={inlineAlignment.rightAlignSiblings} center className="task-details">
                                {/*<a variant="link-orange" className="task-link">*/}
                                {/*    View Task Details*/}
                                {/*</a>*/}

                                <span className="record-id">Task #{item.ID}</span>
                                {(related && (
                                    <span className="record-id restrict">
                                        {related.category} {related.title}
                                    </span>
                                )) || <span className="record-id restrict">{item.Category}</span>}

                                {/*{objBrand && objBrand.title && objBrand.category && (
                                    <div className="task-brand">
                                        <TableKey legacyKey={objBrand.title} />
                                    </div>
                                )}*/}
                                <div className="tag-list">
                                    {item.AssignedLabels &&
                                        item.AssignedLabels.filter(e => Number(e.Member.ID) === Number(me.ID) && !e.NotActive).map(
                                            label => (
                                                <Button key={'user' + label.ID} variant="tag">
                                                    {label.Title}
                                                </Button>
                                            )
                                        )}
                                </div>
                                <div className="user-container">
                                    {item.AssignedMembers.map(me => (
                                        <UserCircle key={'user' + me.ID} member={me} useTag={false} />
                                    ))}
                                </div>
                            </Inline>
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    }

    onStarChange(propertyName, value) {
        const { task } = this.props;

        this.updateTask({
            ...task,
            [propertyName]: value
        });
    }

    updateTask(task) {
        const { onStarClick } = this.props;
        this.setState({ loading: true });
        return updateTaskFunc(task).then(
            result => {
                let updatedTask = cloneDeep(result.data.updateTask);
                this.setState({ item: updatedTask, loading: false });
                if (onStarClick) {
                    onStarClick(updatedTask);
                }
            },
            e => {
                this.setState({ loading: false });
                console.error('Failed to update task.', e);
            }
        );
    }

    renderCard(onClickAction) {
        const { item, loading } = this.state;
        const assignedMembers = item.AssignedMembers.map(x => joinDefined([x.FirstName, x.Surname], ' '));
        const convertDateToCheck = date => !isNullOrUndefined(date);
        const me = getUser();
        const myTask = item && item.AssignedMembers.find(e => !!e && Number(e.ID) === Number(me.ID));
        const myStar = myTask && myTask._join.TaskMembers.Starred;
        const statusClass = getTaskStatusClass(item);
        const updateTick = () => {
            const Completed = !!item.Completed ? null : dateTimeToString(new Date());
            this.onStarChange('Completed', Completed);
        };
        return (
            <div className="task-card dash-card">
                <span
                    style={{
                        position: 'absolute',
                        top: -16,
                        right: -16,
                        zIndex: 5
                    }}
                >
                    <TickableCircle value={!!item.Completed} disabled={loading} onChange={updateTick} />
                </span>
                <Grid container spacing={2}>
                    <Grid item pc>
                        <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                            <p className={`task-status due-date ${statusClass}`}>
                                <span className="status-label">{this.status}</span>
                            </p>
                            {item.Due && (
                                <p className={`due-date ${statusClass}`}>
                                    <span>Due: </span>
                                    {moment(item.Due).format('D MMM YYYY')}
                                </p>
                            )}
                            <CheckableStar
                                value={convertDateToCheck(myStar)}
                                disabled={loading}
                                onChange={checked => {
                                    const AssignedMembers = item.AssignedMembers.map(e => {
                                        e._join = {
                                            TaskMembers: {
                                                Starred:
                                                    Number(e.ID) === Number(me.ID)
                                                        ? checked
                                                            ? new Date()
                                                            : null
                                                        : (e._join && e._join.TaskMembers && e._join.TaskMembers.Starred) || null
                                            }
                                        };
                                        return e;
                                    });
                                    this.onStarChange('AssignedMembers', AssignedMembers);
                                }}
                            />
                        </Inline>
                    </Grid>
                    <Grid item pc>
                        <h1 className="record-id">Task #{item.ID}</h1>
                        <h2 className="task-heading">{item.Title}</h2>
                        <p className="task-description">{item.Description}</p>
                    </Grid>

                    <Grid item pc>
                        <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                            <div>
                                <div className="comments">
                                    <CommentsIcon />
                                    <span>
                                        {item.Audits && item.Audits.edges.filter(e => Number(e.node.Type) === 0).length}
                                    </span>
                                </div>
                            </div>

                            <Typography className="task-assigned">{joinDefined(assignedMembers, ', ')}</Typography>
                        </Inline>
                    </Grid>

                    <Grid item pc>
                        <Button variant="link-orange" className="ViewTaskLink" href={'/work-queue/task/' + item.ID}>
                            View Task
                        </Button>
                    </Grid>
                </Grid>
            </div>
        );
    }

    renderGoals(onClickAction) {
        const { item } = this.state;
        const assignedMembers = item.AssignedMembers.map(x => joinDefined([x.FirstName, x.Surname], ' '));
        return (
            <div className="task-card dash-card">
                <Fab
                    disabled
                    size="small"
                    color="primary"
                    aria-label="Check"
                    className={`fab check ${!item.Completed ? ' incomplete' : ''}`}
                >
                    <TickIcon />
                </Fab>
                <Grid container spacing={2}>
                    <Grid item pc>
                        <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                            <div>
                                <TaskStar disabled />
                            </div>
                            <p className="due-date">
                                <span className="bold">Due: </span>
                                {niceDateFromString(item.Due)}
                            </p>
                        </Inline>
                    </Grid>
                    <Grid item pc>
                        <h2 className="record-id">Goal:</h2>
                        <h3 className="task-heading">{item.Title}</h3>
                        <p className="task-description">{item.Description}</p>
                    </Grid>

                    <Grid item pc>
                        <Button variant="link-orange" onClick={onClickAction ? () => onClickAction(item) : undefined}>
                            {item.Action}
                        </Button>
                    </Grid>

                    <Grid item pc>
                        <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                            <div>
                                <Inline className="comments">
                                    <CommentsIcon />
                                    <span>
                                        {item.Audits && item.Audits.edges.filter(e => Number(e.node.Type) === 0).length}
                                    </span>
                                </Inline>
                            </div>

                            <Typography className="task-assigned">{joinDefined(assignedMembers, ', ')}</Typography>
                        </Inline>
                    </Grid>
                    <Grid item pc>
                        <Button variant="link-orange" className="ViewTaskLink" href={'/work-queue/task/' + item.ID}>
                            View Task
                        </Button>
                    </Grid>
                </Grid>
            </div>
        );
    }

    handleShowRecurrenceModal() {
        this.setState({ showRecurrenceModal: true });
    }

    handleCloseRecurrenceModal() {
        this.setState({ showRecurrenceModal: false });
    }
}

export default compose(withRouter, withStyles({}))(TaskWrapper);
